import {
    MessageBar,
    MessageBarType,
    Spinner,
} from '@fluentui/react';

const GoogleAnalyticsMesageBar = ({
    ga4ValidationStatus,
    setGa4ValidationStatus,
    ga4OverallMessage,
    setGa4OverallMessage,
    ga4DetailedErrors,
    setGa4DetailedErrors,
    validatingGa4
}) => {

    return (
        <div style={{ margin: '15px 0', paddingLeft: '15px', paddingRight: '15px' }}>
            {(ga4ValidationStatus === 'loading' || (validatingGa4 && ga4ValidationStatus === 'idle')) &&
                <Spinner label={ga4OverallMessage || "Validating GA4 setup..."} />
            }
            {ga4ValidationStatus === 'success' && (
                <MessageBar
                    messageBarType={MessageBarType.success}
                    isMultiline={false}
                    onDismiss={() => {
                        setGa4ValidationStatus('idle');
                        setGa4OverallMessage('');
                        setGa4DetailedErrors([]);
                    }}
                    dismissButtonAriaLabel="Close"
                >
                    {ga4OverallMessage}
                </MessageBar>
            )}
            {ga4ValidationStatus === 'warning' && (
                <MessageBar
                    messageBarType={MessageBarType.warning}
                    isMultiline={true}
                    onDismiss={() => {
                        setGa4ValidationStatus('idle');
                        setGa4OverallMessage('');
                        setGa4DetailedErrors([]);
                    }}
                    dismissButtonAriaLabel="Close"
                >
                    {ga4OverallMessage}
                    {ga4DetailedErrors && ga4DetailedErrors.length > 0 && (
                        <ul style={{ margin: '5px 0 0 0', paddingLeft: '20px', textAlign: 'left' }}>
                            {ga4DetailedErrors.map((err, idx) => <li key={idx}>{err}</li>)}
                        </ul>
                    )}
                </MessageBar>
            )}
            {ga4ValidationStatus === 'error' && (
                <MessageBar
                    messageBarType={MessageBarType.error}
                    isMultiline={true}
                    onDismiss={() => {
                        setGa4ValidationStatus('idle');
                        setGa4OverallMessage('');
                        setGa4DetailedErrors([]);
                    }}
                    dismissButtonAriaLabel="Close"
                >
                    {ga4OverallMessage}
                    {ga4DetailedErrors && ga4DetailedErrors.length > 0 && (
                        <ul style={{ margin: '5px 0 0 0', paddingLeft: '20px', textAlign: 'left' }}>
                            {ga4DetailedErrors.map((err, idx) => <li key={idx}>{err}</li>)}
                        </ul>
                    )}
                </MessageBar>
            )}
        </div>
    )
}

export default GoogleAnalyticsMesageBar;